// src/constants/languages.js
export const languages = [
  {
    code: 'cir',
    name: 'language.cyrillic',
    countryCode: 'rs' // Serbia
  },
  {
    code: 'lat',
    name: 'language.latin',
    countryCode: 'rs' // Serbia
  },
  {
    code: 'hu',
    name: 'language.hungarian',
    countryCode: 'hu' // Hungary
  }
];
